import { LabeledText } from "../LabeledText/LabeledText";

import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { FormattedStaticCurrencyNumber } from "@4pace-cpq/core";
import { VMLineItems } from "@4pace-cpq/core/api";

export function TotalListPrice({ item }: { item: VMLineItems }): JSX.Element {
  const { t } = useTranslation();

  const currencyIdentifier = item.currency?.identifier;

  const totalQuantity = item.quantity ?? 1;

  const totalListPrice = item.totalList ? item.totalList / totalQuantity : 0;

  return (
    <LabeledText
      label={t("CPQ:item.property.label.totalList")}
      text={
        <FormattedStaticCurrencyNumber
          value={totalListPrice}
          currencyIdentifier={currencyIdentifier}
        />
      }
    />
  );
}
